import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { usersProvider } from '@/providers';
import { appSetNotification, authTariff } from '@/store';
import { NotificationTypeEnum, UserKindEnum } from '@/types';
import { shouldLoadBillingData } from '@/utils/tariffPolicy';

export const useTariffPlans = () => {
  const dispatch = useDispatch();

  const fetchAndSetTariffs = useCallback(async (userKind?: UserKindEnum) => {
    if (!shouldLoadBillingData()) {
      return;
    }

    const { ok, data, status, message } = await usersProvider.getTariffPlan();

    if (!ok) {
      dispatch(appSetNotification(NotificationTypeEnum.Error, message, status));
      return;
    }

    const { list } = data;

    const filteredTariffs = list.filter((el: any) =>
      el.userKinds.split(',').includes(userKind)
    );

    const prices = filteredTariffs.map((el: any) => ({
      name: el.name,
      description: el.stripeProduct.description,
      prices: el.stripeProduct.prices,
    }));

    dispatch(authTariff(prices));
  }, [dispatch]);

  return { fetchAndSetTariffs };
};
